<template>
  <div class="jzjk-box">
    <div class="jzjk-cont">
      <h1>家长监控说明</h1>
      <div class="par-box">
          <h2>介绍说明：</h2>
          <h3>一、家长监护说明</h3>
          <p>家长监护工程充分考虑家长的实际需求，当家长发现自己的孩子玩游戏过于沉迷的时候，由家长提供合法的监护人资质证明、游戏名称账号、以及家长对于限制强度的愿望等信息，可对处于孩子游戏沉迷状态的账号采取几种限制措施，解决未成年人沉迷网游的不良现象，如限制孩子每天玩游戏的时间区间和长度，也可以限制只有周末才可以游戏，或者完全禁止。</p>
          <h3>二、家长监护服务进度查询</h3>
          <p>如果您已经申请家长监护服务，您可以使用服务号码通过服务热线了解您所提交的服务申请最新处理进展，如：资料是否齐全，是否需要后续补充，账号是否已经进行处理等。服务期间，如果您对需要提交的信息或者处理结果有疑问，或者其他任何问题，您均可以随时联系我们，我们将由专门负责的客服主管为您提供咨询解答服务，或者配合、指导您解决问题。</p>
      </div>
      <div class="par-box">
          <h2>申请说明：</h2>
          <h3>一、申请条件</h3>
          <p>
              1、申请人需为被监护未成年人的法定监护人；<br />
              2、申请人的被监护人年龄小于18周岁；<br />
              3、申请人需为大陆公民， 不含港、澳、台人士。
          </p>
          <h3>二、申请方式</h3>
          <p>
              电话客服：010-65361101～2302<br />
              邮箱：chenxi@huanqiu.com
          </p>
          <h3>三、申请提交资料</h3>
          <p>
              1、监护人信息（包含监护人的身份证明件）。<br />
              2、被监护人信息（包含被监护人所玩游戏相关信息及身份证明件）。<br />
              3、申请人与被监护人的监护关系证明文件（户口簿或有关机关出具的证明文件）。
          </p>
          <h3>四、申请流程</h3>
          <p>
              申请人首先通过自助提交获得服务号码；受理公司在收到提交材料后，将在1个工作日内进行电话回访（联系申请人和被监护人），由受理公司对内容进行核查。资料提交合格且核对正确的情况下，由受理公司对该请求予以受理；资料提交不全面的，由受理公司进行回访，并提示申请人继续补充材料；资料提交不合格且不正确的，受理公司有权对该请求予以拒绝，并附说明理由。
          </p>
          <h3>五、其他要求</h3>
          <p>
              1、申请人应提交较完备的申请材料，对未提供的信息要及时补充；可请熟知电脑、互联网、游戏的人员进行协助，以便提供详实资料；<br />
              2、申请人应保证提交的信息真实有效；对于提供虚假信息或伪造证件，监护关系证明书追究法律责任的权利。 
          </p>
          <h3>六、受理时间</h3>
          <p>
              确认信息完整、账号匹配、被监控方无异议后5个工作日内实施监控。
          </p>
      </div>
      <div class="par-box shenming">
          <h2>家长监护服务免责声明</h2>
          <p>
              您在使用环球网提供的家长监护服务（以下简称“本服务”）之前，请您务必仔细阅读并理解本家长监护服务免责声明（以下简称“本声明”）。除非您已阅读并接受本声明所有条款，否则您无权使用本服务。一旦您使用本服务，您的使用本服务的行为将被视为对本声明全部内容的认可。
          </p>
          <p>1、您承诺以其真实身份申请本服务，并保证有权且所提供的本人及第三方的个人身份资料信息真实、完整、有效。您依据法律规定和本协议约定对所提供的信息承担相应的法律责任。如因您违反有关法律、法规或本协议项下的任何条款而给环球网或任何其他第三方造成损害的，您应当承担由此造成的损害赔偿责任。</p>
          <p>2、环球网有权审查您所提供的身份信息及其他相关资料是否真实、有效。如果您提供的资料不准确，不真实，不合法或无效，环球网保留结束您使用本服务的权利。</p>
          <p>3、为了保护广大玩家的利益，只有您提交的相关信息通过环球网的审核（包括但不限于您所提供资料必须和被申请家长监护的玩家账号的注册资料完全对应），我们才会对您申请本服务的流程做相应的处理。<b>如果您提供的信息未通过审核，环球网有权拒绝向您提供本服务且不承担任何责任。</b></p>
          <p>4、您同意，您因未成年人沉迷网络游戏或其他原因，要求通过本服务限制或禁止未成年人使用环球网游戏服务，您在此不可撤销的承诺和授权环球网有权为处理您的需求以合理方式使用您提交的全部信息（包括您本人及您提供的第三方个人信息），包括但不限于以下用途。环球网将会根据国家法律、法规的规定对于您提供的信息保密。</p>
          <p class="sub-level">
              <b>(1) 环球网可自主或委托合作机构通过依法运营的政府部门数据库、商业化数据库以及其他第三方机构对您提供的信息进行整理、保存及对比等处理，并将结果反馈给环球网；</b>
          </p>
          <p class="sub-level">
              <b>(2) 向您提供环球网的服务；</b>
          </p>
          <p class="sub-level">
              <b>(3) 改善环球网的产品或服务；</b>
          </p>
          <p class="sub-level">
              <b>(4) 在环球网提供服务时，用于身份验证、客户服务、安全防范、诈骗监测、存档和备份用途，确保环球网向您提供的产品和服务的安全性；</b>
          </p>
          <p class="sub-level">
              <b>(5) 为使您知晓自己使用环球网网站服务的情况或了解环球网的相关服务，向您发送服务状态的通知等信息；</b>
          </p>
          <p class="sub-level">
              <b>(6) 使环球网更加了解您如何接入和使用相关服务，从而针对性地回应您的个性化需求，例如语言设定、位置设定、个性化的帮助服务和指示；</b>
          </p>
          <p class="sub-level">
              <b>(7) 预防或禁止非法的活动；</b>
          </p>
          <p class="sub-level">
              <b>(8) 经您许可的其他用途。</b>
          </p>
          <p>
              5、若第三方对您申请控制游戏帐号的行为提出权属异议，您同意并授权环球网向该第三方或司法机关提供您提交的申请资料，并同意环球网可依据本协议规定或司法机关的指令，视情节严重程度，<b>对您做出暂时或永久的禁止登录（即封号）、冻结本服务等处理措施。</b>
          </p>
          <p>
              6、您理解并承诺，环球网对玩家游戏帐号的调查和控制措施均是应您申请所为，<b>您自愿承担该玩家游戏帐号因限制措施所遭受的任何损失（包括但不限于取证费用、诉讼费用、民事赔偿等）。</b>
          </p>
          <p>
              7、您保证，只对有法定监护关系的未成年人有使用权的游戏帐号提出申请，不得对其他用户的游戏帐号进行绑定。
          </p>
          <p>
              8、<b>您理解并承诺，环球网按照您的申请对游戏帐号采取限制措施，即视为您认可该游戏帐号在限制措施内的所有游戏行为和消费行为，包括但不限于符合消费限额的消费行为以及满足游戏时长限制的游戏行为，且不可撤销的放弃对环球网的任何主张。</b>
          </p>
          <p>
              9、如您违反法律法规、本协议的规定，环球网有权进行独立判断并随时限制或终止为您提供服务，无须向您发出任何提前通知。由此，导致或产生的任何损失或第三方主张的任何索赔、要求等（包括但不限于申请失败，用户资料、邮件和游戏道具及相关数据等的清空等），由您自行承担。
          </p>
          <p>
              10、在任何情况下，环球网不对因不可抗力导致的您在使用环球网游戏服务过程中遭受的损失承担责任。该等不可抗力事件包括但不限于国家法律、法规、政策及国家机关的命令及其他政府行为或者其它的诸如地震、水灾、雪灾、火灾、海啸、台风、罢工、战争等不可预测、不可避免且不可克服的事件。
          </p>
          <p>
              11、您理解并同意，当被申请人年满十八周岁后，本服务自动终止。
          </p>
          <p>
              12、为提升服务，环球网权随时自行修改本服务功能及规则而不需通知您。
          </p>
          <p>
              13、<b>与本免责声明有关的一切争议，均应以环球时报在线（北京）文化传播有限公司所在地有管辖权法院为管辖法院。</b>
          </p>
          <p class="end">环球时报在线（北京）文化传播有限公司</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "control",
  data() {
    return {
      form: {}
    };
  },
  methods: {
    isMobileFn() {
      if (this.isMobile) {
        this.$router.push({
          name: "mregister",
          agreeStatus: true,
          params: { registForm: this.$route.params.registForm }
        });
      } else {
        window.close();
      }
    }
  }
  // created(){
  //   if (this.$router.params.registForm) {
  //     this.form
  //   }
  // }
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
body,button{
  margin:0;padding:0;
}
*html{
  background-image:url(about:blank);background-attachment:fixed;
}

.jzjk-box{
    font-size:14px;
    font-family:"Microsoft Yahei","微软雅黑","ProLiHei Pro Medium",SimHei,SimSun,"宋体",Arial,Helvetica;
    text-align:center;
    background: #f7f7f7;
    padding-bottom:50px;
    color:#777;
}
button,h1{font-size:12px;}
dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,ul{margin:0;padding:0;text-align:left;}
dd,dl,dt,li,ol,ul{list-style:none;}
img{border:0;}
input,select,table,td,textarea,th,tr{
  font-size:12px;font-family:Arial,Helvetica,sans-serif;}
h3{font-size:14px;}
h4{font-size:13px;}
input,textarea{font-family:"Microsoft Yahei","微软雅黑","ProLiHei Pro Medium",SimHei,SimSun,"宋体",Arial,Helvetica;}
a,a:active,a:hover,a:visited{background:0 0;text-decoration:none;}
a:hover{text-decoration:underline;}


.jzjk-cont{
    
    overflow: hidden;
    width:900px;margin:0 auto;
}
.par-box{
    overflow:hidden;margin:30px 0 0;padding-bottom:20px;
    background:#fff;border-radius:4px;
}
h1{
    display:block;height:60px;line-height:60px;font-size:32px;text-align:center;color:#000;
    margin:20px 0 10px;
}
h2,h3,b{color:#000;}
.par-box h2,.par-box h3,.par-box p{
    display:block;
}
.par-box h2{
    background:#007ed7;color:#fff;text-indent:22px;font-size:18px;height:36px;line-height:36px;
}
.par-box h3{
    padding:10px 30px;font-size:16px;line-height:28px;
}
.par-box p{
    padding:0 30px 10px 62px;line-height:24px;
}
.shenming h2{
    margin-bottom:20px;
}
.shenming p{
    line-height:28px;font-size:14px;
}
.shenming p.sub-level{
    padding-left:80px;
}
.shenming p.end{
    text-align:right;color:#000;font-size:16px;padding:20px 30px 10px 68px;
}
.blueBtn{
    display:block;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    font-size: 18px;
    background: #007ed7;
    border: none;
    color: #fff;
    width:180px;
    outline: 0;
    margin:30px auto;
}
</style>

</template>
<script>
export default {
  name: "agreement",
  data() {
    return {
      form: {}
    };
  },
  methods: {
    isMobileFn() {
      if (this.isMobile) {
        this.$router.push({
          name: "mregister",
          agreeStatus: true,
          params: { registForm: this.$route.params.registForm }
        });
      } else {
        window.close();
      }
    }
  }
  // created(){
  //   if (this.$router.params.registForm) {
  //     this.form
  //   }
  // }
};
</script>
<style lang="scss">
html,
body {
  width: 100%;
  height: 100%;
}
</style>
<style lang="scss" scoped>
img {
  border: none;
}
a {
  text-decoration: none;
  color: #252525;
}
a:hover {
  text-decoration: underline;
  color: #d00005;
}
h5 {
  font-weight: normal;
}
h5 em {
  font-style: normal;
  color: #93090f;
  margin: 0 5px;
  display: inline-block;
}
h5 em a {
  color: #93090f;
  margin: 0 2px;
}
em,
i {
  font-style: normal;
}
.algCen {
  text-align: center;
}
input {
  outline: none;
}

.agreement {
  background: url("../../assets/images/topRep.png") repeat-x;
  background-color: #eeeeee;
}

.backHome {
  margin: 0 12px 0 0;
}

.wrap {
  background: url("../../assets/images/cloud.jpg") no-repeat center 125px;
}

.wrap {
  width: 100%;
  overflow: hidden;
  margin: 0 auto;
  position: relative;
  min-height: 700px;
}

.wrapConOut {
  width: 970px;
  min-height: 750px;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
}

.wrapCon {
  width: 970px;
  overflow: hidden;
  margin-top: 8%;
  position: relative;
}

.passLogo,
.regBtn,
.verifyInput,
.regInpTxt,
.inputWrong,
.verifyShow,
.logBtn,
.blueBtn {
  background: url("../../assets/images/gatePass.png") no-repeat;
}

.passLogo {
  position: absolute;
  left: 5px;
  top: 5px;
  width: 210px;
  height: 43px;
  background-position: 0 0;
  text-indent: -9999px;
}

.backHomeBox {
  position: absolute;
  right: 0px;
  top: 30px;
  display: block;
  width: 210px;
  height: 18px;
  color: #cacaca;
  font-size: 14px;
  text-align: right;
  padding-right: 10px;
}

.backHome,
.webMap {
  display: inline-block;
  background-position: 0 0;
  text-align: right;
  color: #4c99e8;
  font-size: 14px;
  line-height: 18px;
}

.webMap {
  margin: 0 0 0 6px;
}

.mailActCon {
  background: url("../../assets/images/gateBottom.jpg") no-repeat left bottom;
}

.mailActCon {
  width: 970px;
  margin: 80px auto 25px auto;
  background-color: #fff;
}

.mailActConInner {
  width: 970px;
  height: 560px;
  overflow: hidden;
  position: relative;
}

.gateHd {
  background: url("../../assets/images/topBg.jpg") no-repeat;
}

.gateHd {
  width: 100%;
  height: 70px;
  overflow: hidden;
  color: #fff;
  font-size: 29px;
  text-align: center;
  line-height: 70px;
}

.agreeMentBox {
  margin: 30px 40px;
}

.agreeMentArea {
  width: 890px;
  height: 360px;
  line-height: 30px;
  overflow-x: hidden;
  overflow-y: scroll;
  font-size: 14px;
  color: #2b2b2b;
}

.regBtn,
.blueBtn {
  border: none;
  display: inline-block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  background-position: 0 -70px;
  clear: both;
  margin-left: 0px;
  float: left;
  margin-left: 100px;
  margin-top: 30px;
}

.agreeMentBox .blueBtn {
  margin-left: 330px;
}

.agreeMentBox .blueBtn:hover {
  border: none;
  display: inline-block;
  width: 220px;
  height: 40px;
  line-height: 40px;
  border-radius: 3px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  cursor: pointer;
  clear: both;
  margin-left: 330px;
  float: left;
  margin-top: 30px;
  background: url("../../assets/images/gatePass.png") no-repeat 0 -70px !important;
  box-shadow: unset !important;
}

.foot {
  width: 970px;
  margin: 0 auto;
  overflow: hidden;
  padding-bottom: 10px;
}

.fLink {
  height: 37px;
  text-align: center;
  color: #b0b0b0;
  font-size: 14px;
}

.flinkMain {
  width: 960px;
  margin: 0 auto;
  height: 35px;
  line-height: 38px;
}

.fLink a {
  color: #b0b0b0;
  text-decoration: none;
  font-size: 12px;
  height: 32px;
  line-height: 32px;
  margin: 0 10px;
  font-family: "宋体";
}

.copyMain {
  width: 950px;
  margin: 0 auto;
  text-align: center;
  color: #b0b0b0;
}

.copyMain em {
  margin-left: 50px;
  font-style: normal;
  font-size: 12px;
}

.copyMain a {
  color: #b0b0b0;
  margin: 0 5px;
  display: inline-block;
  font-size: 12px;
}

strong {
  font-weight: unset;
}
@media only screen and (max-width: 767px) {
  strong {
    font-weight: bolder;
  }

  .agreement {
    background: #f5f5f5 url("../../assets/images/magreement.png") repeat-x;
    background-size: 100%;
  }

  .wrap,
  .wrapConOut,
  .agreeMentArea {
    height: 100%;
    min-height: 100%;
  }

  .agreeMentArea {
    font-size: 9px;
    line-height: 15px;
    text-align: justify;
    color: #4c4c4c;
  }

  .wrapConOut,
  .wrapCon,
  .mailActCon,
  .mailActConInner,
  .agreeMentArea {
    width: 100%;
  }

  .wrap {
    background: unset;
  }

  .wrapCon {
    margin-top: 100px;
  }

  .agreeMentBox {
    margin: 30px 30px;
  }

  .mailActCon {
    background: unset;
    margin: 0 auto;
  }

  .mailActConInner {
    height: 100%;
  }

  .backHomeBox,
  .passLogo,
  .gateHd,
  .foot {
    display: none;
  }

  .agreeMentBox .blueBtn {
    margin: 0 auto;
    float: unset;
    width: 75px;
    height: 30px;
    font-size: 13px;
    line-height: 30px;
  }

  .agreeMentBox .blueBtn:hover {
    border: none;
    display: inline-block;
    width: 75px;
    height: 30px;
    line-height: 30px;
    border-radius: 3px;
    color: #fff;
    font-size: 13px;
    text-align: center;
    cursor: pointer;
    clear: both;
    float: unset;
    margin: 0 auto;
    background: unset;
    box-shadow: unset !important;
  }

  .btn {
    margin: 0 auto;
    width: 100%;
    text-align: center;
    margin-top: 24px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/control/index.vue